// extracted by mini-css-extract-plugin
module.exports = {"ButtonStandardArrowIcon":"ButtonStandardArrow_ButtonStandardArrowIcon__2DX6X"};